exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OfferChilds .nowrap {\n  white-space: nowrap; }\n\n#Loader {\n  padding-top: 0 !important;\n  margin: 0 !important; }\n  #Loader span {\n    width: 40px;\n    height: 40px; }\n  #Loader p {\n    visibility: hidden;\n    opacity: 0;\n    font-size: 0; }\n\n.alert-child {\n  font-weight: 400;\n  text-align: center;\n  margin: auto;\n  word-wrap: break-word;\n  font-size: .9em;\n  line-height: 1.375em;\n  flex-grow: 1;\n  display: flex;\n  width: 100%; }\n  .alert-child strong {\n    font-weight: 600; }\n", ""]);

// exports
